/**
 * Majburiy 2FA sozlash: roli uchun 2FA majburiy (Admin -> Settings -> Security), lekin hali sozlanmagan xodim
 * platformaga kirishdan oldin shu yerda sozlaydi. Backend ham shu vaqtgacha API'ni yopiq tutadi
 * (accounts/middleware.py). Sozlangach zaxira kodlar, so'ng login intro va platforma.
 */
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, ApiError } from "@/lib/api";
import { meKey, useLogout } from "@/features/auth/hooks";
import { startLoginIntro } from "@/features/auth/intro";
import { ErrorState, PageLoading } from "@/components/ui/misc";
import { BackupCodes, TotpEnrollment, type TotpEnabled, type TotpSetup } from "@/pages/profile/TotpEnrollment";
import { AuthLayout } from "./AuthLayout";

export function TwoFactorSetupPage() {
  const { t } = useTranslation("auth");
  const qc = useQueryClient();
  const logout = useLogout();
  const [setup, setSetup] = useState<TotpSetup | null>(null);
  const [qrVersion, setQrVersion] = useState(0);
  const [enabled, setEnabled] = useState<TotpEnabled | null>(null);
  const start = useMutation({
    mutationFn: () => api.post<TotpSetup>("/api/auth/2fa/setup/"),
    onSuccess: (res) => {
      setSetup(res);
      setQrVersion((v) => v + 1);
    },
  });

  // Sahifa ochilishi bilan bir marta: ikkinchi so'rov kalitni almashtirib, ko'rsatilgan QR'ni eskirtirardi
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    start.mutate();
  }, [start]);

  return (
    <AuthLayout
      wide
      title={t("twofaSetup.title")}
      subtitle={t("twofaSetup.subtitle")}
      footer={
        <button type="button" className="text-primary hover:underline" onClick={() => logout.mutate()}>
          {t("twofaSetup.signOut")}
        </button>
      }
    >
      {enabled ? (
        <BackupCodes
          codes={enabled.backup_codes}
          doneLabel={t("twofaSetup.continue")}
          onDone={() => {
            // Endi platforma ochiq: brend intro va uning ortidan platforma
            startLoginIntro();
            qc.setQueryData(meKey, enabled.user);
          }}
        />
      ) : setup ? (
        <TotpEnrollment setup={setup} qrVersion={qrVersion} onEnabled={setEnabled} />
      ) : start.isError ? (
        <ErrorState message={start.error instanceof ApiError ? start.error.message : t("twofaSetup.failed")} onRetry={() => start.mutate()} />
      ) : (
        <PageLoading />
      )}
    </AuthLayout>
  );
}
